module.exports = __webpack_public_path__ + "img/7d72616.png";